module.exports = __webpack_public_path__ + "static/fonts/SourceSansPro-SemiBoldItalic.75d2f60.eot";